// Fetch wrapper that adds custom user agent information to the request headers.
// This is used to identify the client application making the request, which can be useful for logging
// IMPORTANT please avoid "parameter creep":
// any new custom parameters should be added to the `AuthClientOptions` interface
// and NOT appended as a new parameter to the `authFetch` function.

interface XClientAppInfo {
  environment: string;
  appName: string;
  appVersion: string;
}

interface AuthClientOptions {
  xClientAppInfo: XClientAppInfo; // Custom user agent info
}

const authFetch = async (
  url: string,
  params: RequestInit, // standard Fetch API parameters
  authClientOptions: AuthClientOptions, // any custom options needed for the auth client
): Promise<Response> => {
  const {
    xClientAppInfo: { environment, appName, appVersion },
  } = authClientOptions;
  const customUserAgentInfo = `app:${appName} env:${environment} version:${appVersion}`;

  return fetch(url, {
    ...params,
    headers: {
      ...params.headers,
      'X-Client-App-Info': customUserAgentInfo,
    },
  });
};

export default authFetch;
